// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/lad/boyadem-lad-swipe-2.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "boyadem-lad-swipe-2 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 1.aseprite": {
      frame: {
        x: 48,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 2.aseprite": {
      frame: {
        x: 96,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 3.aseprite": {
      frame: {
        x: 144,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 4.aseprite": {
      frame: {
        x: 192,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 5.aseprite": {
      frame: {
        x: 240,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 6.aseprite": {
      frame: {
        x: 288,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
    "boyadem-lad-swipe-2 7.aseprite": {
      frame: {
        x: 336,
        y: 0,
        w: 48,
        h: 48,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 48,
      },
      sourceSize: {
        w: 48,
        h: 48,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "boyadem-lad-swipe-2.png",
    format: "RGBA8888",
    size: {
      w: 384,
      h: 48,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    anim: [
      "boyadem-lad-swipe-2 0.aseprite",
      "boyadem-lad-swipe-2 1.aseprite",
      "boyadem-lad-swipe-2 2.aseprite",
      "boyadem-lad-swipe-2 3.aseprite",
      "boyadem-lad-swipe-2 4.aseprite",
      "boyadem-lad-swipe-2 5.aseprite",
      "boyadem-lad-swipe-2 6.aseprite",
      "boyadem-lad-swipe-2 7.aseprite",
    ],
  },
};
export const boyademladswipe2 = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const anim = new AnimatedSprite(spritesheet.animations.anim);

  anim.width = 96;
  anim.height = 96;
  anim.anchor.set(0.5, 0.5);

  return anim;
};
